import { useContext } from 'react';
import { AuthContext } from './AuthProvider';

export { UserRole } from './types';

/**
 * Custom hook to be able to check if a user is authenticated, and allows us to login or logout throughout the application
 * @returns
 */
const useAuth = () => {
  const authContext = useContext(AuthContext);

  return {
    login: authContext.login,
    logout: authContext.logout,
    isAuthenticated: authContext.isAuthenticated,
    isInitialized: authContext.isInitialized,
    checkIfRoleIsIncluded: authContext.checkIfRoleIsIncluded,
  };
};

export default useAuth;
